var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.999,
    height: 14.449,
    viewBox: "0 0 20.999 14.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payable",
    transform: "translate(-37 -105.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365934",
    "data-name": "Path 365934",
    d: "M37,270.21v6.543h2.17V270.21Zm1.373,2.45a.288.288,0,0,1-.575,0v-1.606a.288.288,0,0,1,.575,0Z",
    transform: "translate(0 -156.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365935",
    "data-name": "Path 365935",
    d: "M107.481,300.086a.767.767,0,0,1-.42.688c-.85.431-5.094,2.607-5.248,2.7-1.765,1.1-5.111-.088-6.094-.477a6.966,6.966,0,0,0-1.438-.2V299h.431a4.283,4.283,0,0,1,1.877.442,10.206,10.206,0,0,0,2.616.459l2.13.037a.725.725,0,0,1,.712.738v.087a.719.719,0,0,1-.065.288l-.009.02a.72.72,0,0,1-.147.2.711.711,0,0,1-.516.2l-2.745-.048a.288.288,0,1,0-.01.575l2.745.048h.024a1.3,1.3,0,0,0,1.127-.651l3.915-1.995a.767.767,0,0,1,1.117.684Z",
    transform: "translate(-54.534 -184.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365936",
    "data-name": "Path 365936",
    d: "M134.5,134.284l-.439-.008a1.3,1.3,0,0,1-1.277-1.323v-.086a1.308,1.308,0,0,1,.649-1.1,3.65,3.65,0,1,0,1.066,2.576A.555.555,0,0,0,134.5,134.284Zm-3.364,2.317v.493a.288.288,0,0,1-.575,0V136.6a1.29,1.29,0,0,1-.9-.756.288.288,0,0,1,.53-.224.716.716,0,1,0,.66-.994,1.291,1.291,0,0,1-.288-2.55v-.492a.288.288,0,0,1,.575,0v.492a1.286,1.286,0,0,1,.863.671.288.288,0,1,1-.513.261.716.716,0,1,0-.638,1.04,1.291,1.291,0,0,1,.288,2.55Z",
    transform: "translate(-85.878 -24.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365937",
    "data-name": "Path 365937",
    d: "M252.158,111.25v3.8h-.431a4.283,4.283,0,0,1-1.877-.442,10.218,10.218,0,0,0-2.617-.459l-1.418-.024h-.01l-.7-.012a.725.725,0,0,1-.712-.738v-.087a.724.724,0,0,1,.618-.7.762.762,0,0,1,.119-.008l2.745.048h.005a.288.288,0,0,0,0-.575L245.138,112h-.051a4.226,4.226,0,0,0-1.267-1.007c.745-.384.785-.41.8-.422,1.765-1.1,5.111.088,6.094.477A6.906,6.906,0,0,0,252.158,111.25Z",
    transform: "translate(-196.905 -4.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365938",
    "data-name": "Path 365938",
    d: "M429.74,105.31v6.543h2.17V105.31Zm1.373,5.7a.288.288,0,1,1-.575,0V109.4a.288.288,0,1,1,.575,0Z",
    transform: "translate(-373.911)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayable);
export default __webpack_public_path__ + "static/media/payable.e2743cfc64807720f6630a8891698405.svg";
export { ForwardRef as ReactComponent };